<template>

  <t-page>

    <DepartmentDialog :no-option-add="noOptionAdd" @onSubmit="onDepartmentDialog"/>

    <t-page-form card :submit-text="currentPage.singularTitle"
                 :title="t('form-of')+currentPage.pageTitle"
                 :command="command" :status="status" :generalErrors="generalErrors" @onSubmit="onSubmit"
                 :check-errors-again="checkErrorsComponent"
                 :go-back-title="t('go-back-list')" :go-back-to="currentPage.name" :busy="!pageFormIsLoaded">

      <t-input v-model="form.userId" hidden/>

      <t-form-card class="mt-2" title="Dados Básicos">

        <t-input v-model="form.name" :add-error="error.name" label="Nome" required/>

        <t-input v-model="form.preferentialCompanyId"
                 :options="companyOptions" required label="Empresa Preferencial" first-default
                 help="Caso possua acesso a mais que uma empresa, deverá especificar qual a preferencial padrão deste usuário."
                 select/>

        <t-input v-model="form.whatsapp" class-icon-group="icon-whatsapp-colored" tel label="WhatsApp">
          <template #input-icon>
            <b-icon-whatsapp/>
          </template>
        </t-input>

        <t-input v-model="form.professionalRegistration" label="Registro Profissional"
                 help="Informe qual entidade de classe e o registro caso desejado."
                 placeholder="CREA/CAU/Outra entidade de classe"/>


        <t-input v-model="form.note" label="Observações" max-length="500" textarea/>


      </t-form-card>

      <t-form-card title="Acesso">


        <t-msg info v-if="oldEnableAccessCode !== form.enableAccessCode && command === 'update' && pageFormIsLoaded">
          Alterando o usuário de Acesso via Código para Acesso via e-mail, será realizada a troca da senha para uma nova
          temporária e um e-mail de boas-vindas será enviada ao usuário para que o mesmo realize a troca da senha
          temporária.
        </t-msg>


        <b-row v-if="form.enableAccessCode">

          <t-input cols="6" v-model="form.username" :add-error="error.username" label="Código de Acesso"
                   only-numbers min-length="3" max-length="10" required
                   :small="'Prefixo  \''+accountNumber+'\' padrão da sua conta Onlaine'">
            <template #input-group-prepend>{{ accountNumber }}.</template>
          </t-input>

          <t-input v-model="form.pinAccess" cols="6" :add-error="error.pinAccess" min-length="6" max-length="6"
                   label="PIN" only-numbers required/>

        </b-row>


        <t-input :disabled="form.typeMaster" v-else v-model="form.username" :add-error="error.username"
                 label="E-mail de Acesso"
                 email required/>

        <b-form-checkbox class="mb-3" v-model="form.enableAccessCode" switch>
          Acessar via código?
          <t-help
              title="Opção indicada somente em casos onde os usuários não possuem e-mail de acesso, desta forma não será possível recuperar a senha, pois não há um e-mail vinculado."/>
        </b-form-checkbox>

        <t-input v-if="form.enableAccessCode" :disabled="form.typeMaster" v-model="form.profileId"
                 :options="profileOnlyAccessCodeOptions"
                 label="Perfil de Acesso habilitado para acesso via Código de Acesso" required select
                 help="Para incluir novo perfil de acesso, utilize o menu 'Administração > Configuração > 'Perfis de Acesso' e deixe marcado a opção 'Habilitar para acesso via Código'."/>

        <t-input v-else :disabled="form.typeMaster" v-model="form.profileId"
                 :options="profileAllOptions"
                 label="Perfil de Acesso" required select
                 help="Para incluir novo perfil de acesso, utilize o menu 'Administração > Configuração > 'Perfis de Acesso'."/>


        <b-form-checkbox class="mt-2 mb-2" v-model="form.enableExternalAccess" switch>
          Liberar acesso fora da rede interna?
          <t-help
              title="Por segurança deixe os usuários com restrição a rede interna, para liberar os IP da rede interna Acesse<br /><a href=javascript:go('admin-access-control')>Controle de Acesso por IP</a>"/>
        </b-form-checkbox>

        <t-msg danger v-if="form.enableExternalAccess">Usuário com Acesso Externo Liberado e maior risco de segurança
        </t-msg>

      </t-form-card>

      <t-form-card title="Pertence ao Grupo">

        <b-form-checkbox class="ml-3" v-for="item in groupUserOptions" :key="item.value"
                         :checked="form.groupUsers.find(a => a.groupUserId === item.value) != null"
                         @change="addGroupSelected($event,item.value)">
          {{ item.text }}
        </b-form-checkbox>

      </t-form-card>


      <t-form-card title="Alçada de Acesso">

        <b-form-checkbox class="col-sm-12 ml-2 mb-3" v-model="form.enableAllCompanies" switch>
          Habilitar todas empresas a este usuário?
          <t-help
              title="Você poderá especificar quais as empresas desejadas, basta desmarcar esta opção e especificar quais as empresas abaixo."/>
        </b-form-checkbox>

        <t-table
            v-if="!form.enableAllCompanies"
            enable-checked
            v-model="companiesIds"
            :items="companiesList"
            :fields="viewFieldsPageCompanies"
            title-items="empresa"
            link-primary-column="name"
            table-bordered
            disable-actions-column
            primary-key-column="companyId">

          <template #first-column="{item}">
            {{ item.name }}
          </template>

        </t-table>

        <div v-if="getRenderRule('account-module-arch')">

          <b-form-checkbox class="col-sm-12 ml-2 mb-3 mt-3" @change="getAllEnterprises()"
                           v-model="form.enableAllEnterprises" switch>
            Habilitar todos empreendimentos a este usuário?
            <t-help
                title="Você poderá especificar quais os locais desejados, basta desmarcar esta opção e especificar quais os locais abaixo."/>
          </b-form-checkbox>

          <t-table
              v-if="!form.enableAllEnterprises"
              enable-checked
              v-model="enterprisesIds"
              :items="enterprisesList"
              :fields="viewFieldsPageEnterprises"
              title-items="local"
              link-primary-column="title"
              table-bordered
              disable-actions-column
              primary-key-column="enterpriseId">

            <template #first-column="{item}">
              {{ item.title }}
            </template>

          </t-table>

        </div>


      </t-form-card>

      <t-input-status v-model="form.status"/>


    </t-page-form>

  </t-page>

</template>
<script>

import DepartmentDialog from "@/views/modules/admin/DepartmentDialog"
import pageDefaultMixin from "@/mixins/page/pageDefaultMixin"
import pageFormMixin from "@/mixins/page/pageFormMixin"
import http from "@/services/config/http-common";
import ui from "@/assets/scripts/ui";
import pageViewService from "@/services/modules/setting/PageView.service";
import CompanyService from "@/services/modules/admin/Company.service";
import EnterpriseService from "@/services/modules/place/Enterprise.service";

export default {
  mixins: [pageDefaultMixin, pageFormMixin],
  name: 'UserForm',
  components: {DepartmentDialog},
  data() {
    return {
      path: "", //Utilizar somente quando fora do padrão
      genKey: false, //Utilizar quando desejar gerar chave temporária
      fieldKey: "userId",
      form: {
        userId: 0,
        userNumber: 0,
        name: "",
        whatsapp: "",
        enableAccessCode: false,
        enableExternalAccess: true,
        enableAllCompanies: true,
        enableAllEnterprises: true,
        professionalRegistration: "",
        preferentialCompanyId: 0,
        username: "",
        pinAccess: "",
        nome: "",
        typeMaster: false,
        profileId: 0,
        createOperator: false,
        createInspector: false,
        status: 1,
        groupUsers: [],
        companies: [],
        enterprises: [],
      },
      oldEnableAccessCode: false,
      error: {//Campos que podem receber retorno de erro do backend
        username: "",
        pinAccess: "",
        preferentialCompanyId: "",
      },
      //--------------------------------------------------------------------------------------
      //Início de campos personalizados desta tela
      companyOptions: [],
      accountModule: "",
      accountNumber: "000",
      noOptionAdd: "", //Usado para armazenar o começo do nome digitado para inserção rápida em dialogos na página.
      profileAllOptions: [],
      profileOnlyAccessCodeOptions: [],
      departmentOptions: [],
      groupUserOptions: [],
      companiesIds: [],
      companiesList: [],
      viewFieldsPageCompanies: [],
      enterprisesIds: [],
      enterprisesList: [],
      viewFieldsPageEnterprises: [],
      //--------------------------------------------------------------------------------------
    }
  },
  methods: {

    mountedPrepare() {

      this.accountModule = ui.getAccountModule()

    },
    async mountedContinued() {

      await pageViewService.getViewFieldsByPage(31, true, [""]).then((response) => {
        this.viewFieldsPageCompanies = response
      }).catch(error => this.responseError(error))

      await pageViewService.getViewFieldsByPage(192, true, [""]).then((response) => {
        this.viewFieldsPageEnterprises = response
      }).catch(error => this.responseError(error))

      await CompanyService.getAllCompanies().then((list) => {
        this.companiesList = list
        this.companiesIds = this.convertObjectToArrayIds(this.form.companies, "companyId")
      }).catch(error => this.responseError(error))

      await CompanyService.selectList("").then((list) => {
        this.companyOptions = list
      }).catch(error => this.responseError(error))

      await this.getAllEnterprises()

      if (this.isUpdate()) {
        this.oldEnableAccessCode = this.form.enableAccessCode
      }

      await http.list("admin/user/selectRelationList").then((response) => {

        this.accountNumber = response.accountNumber
        this.profileAllOptions = response.profileAllOptions
        this.profileOnlyAccessCodeOptions = response.profileOnlyAccessCodeOptions
        this.departmentOptions = response.departmentOptions
        this.groupUserOptions = response.groupUserOptions

      }).catch(error => this.responseError(error))


      this.pageFormIsLoaded = true

    },
    async onSubmit() {

      this.form.companies = this.convertArrayIdsToObject(this.companiesIds, "companyId")
      this.form.enterprises = this.convertArrayIdsToObject(this.enterprisesIds, "enterpriseId")

      //Por padrão sempre irá incluir um usuário operador/inspetor relacionado, desde que o módulo este habilitado.
      if (this.isInsert()) {
        if (this.getRenderRule('account-module-production')) {
          this.form.createOperator = true
        } else if (this.getRenderRule('account-module-arch') || this.getRenderRule('account-module-estate') || this.getRenderRule('account-module-condo')) {
          this.form.createInspector = true
        }
      }

      if ((this.isInsert() || this.isUpdate()) && (this.form.groupUsers == null || this.form.groupUsers.length === 0)) {
        ui.msgError(this, "Selecione pelo menos 1(um) grupo que o usuário pertence.")
      } else {
        await this.setSendingDefault()
      }

    },
    //--------------------------------------------------------------------------------------
    //Início de métodos personalizados desta tela

    async getAllEnterprises() {

      if (!this.form.enableAllEnterprises) {

        this.pageFormIsLoaded = false

        await EnterpriseService.getAllEnterprises().then((list) => {
          this.enterprisesList = list
          this.enterprisesIds = this.convertObjectToArrayIds(this.form.enterprises, "enterpriseId")
        }).catch(error => this.responseError(error))

        this.pageFormIsLoaded = true
      }

    },

    addGroupSelected(checked, id) {

      if (checked) {
        //Adicionar
        const el = this.form.groupUsers.find(a => a.groupUserId === id)
        if (el == null)
          this.form.groupUsers.push({groupUserId: id})
      } else {
        //Remover
        const indexRemove = this.form.groupUsers.findIndex(a => a.groupUserId === id)

        if (indexRemove >= 0)
          this.form.groupUsers.splice(indexRemove, 1)

      }

    },

    onDepartmentDialog(itemInserted) {

      this.form.departmentId = itemInserted.value
      this.departmentOptions.push(itemInserted); //Simples, pois é uma lista não agrupada

    },

    //--------------------------------------------------------------------------------------

  },
  async mounted() {

    this.mountedPrepare()

    await this.mountedForm(true, false)

    await this.mountedContinued()

  },

}
</script>
